import passwordResetImg from '@assets/img/svg/password-reset.svg'
import { withTransaction } from '@elastic/apm-rum-react'
import { Button, JessicaJonesService, LogService, ToastHelper, User, UserHelper } from '@hub/shared'
import { SqLoader } from '@squidit/react-css'
import { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import './password.page.scoped.scss'
import './password.page.scss'

const PasswordPage = ({ configs, homeNavigationPath, impersonateUser = null }: any) => {
  const [loading, setLoading] = useState<boolean>(true)
  const jessicaService = useMemo(() => new JessicaJonesService(), [])
  const logService = useMemo(() => new LogService(), [])
  const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false)
  const [user, setUser] = useState<User | null>(null)
  const userHelper = useMemo(() => new UserHelper(), [])
  const { t } = useTranslation('passwordPage')
  const toast = new ToastHelper().toast
  const navigate = useNavigate()
  logService.init('Password Logged Reset Page')

  useEffect(() => {
    userHelper.getUser().then((user) => {
      setUser(user)
      setLoading(false)
    })
  }, [userHelper])

  async function onSubmit(event: any) {
    event.preventDefault()
    const email = user?.profileadditionalinfo?.email
    if (email && !loadingSubmit) {
      setLoadingSubmit(true)
      try {
        const emailVerify = await jessicaService.passwordRequest(email?.toLowerCase())
        if (emailVerify.message === 'reset_password_email' || emailVerify.message === 'user_not_has_password') {
          toast.success(t('toastMessages.reset_password_email'), {
            closeButton: true,
            className: 'full text-bold',
            position: `${window.innerWidth > 991 ? 'top' : 'bottom'} center`,
            notOverClick: true,
            immediately: true,
          })
        }
        if (emailVerify.message === 'user_not_registered') {
          toast.warning(t('toastMessages.user_not_registered', { email: email }), {
            closeButton: true,
            className: 'full text-bold',
            position: `${window.innerWidth > 991 ? 'top' : 'bottom'} center`,
            notOverClick: true,
            immediately: true,
            duration: 3600000,
          })
        }
        setLoadingSubmit(false)
      } catch (err) {
        toast.error(t('toastMessages.unexpected', { email: email }), {
          closeButton: true,
          className: 'full text-bold',
          position: `${window.innerWidth > 991 ? 'top' : 'bottom'} center`,
          notOverClick: true,
          immediately: true,
          duration: 3600000,
        })
        logService.error({
          message: 'Error to send reset password email',
          user: email,
          error: err,
        })
        setLoadingSubmit(false)
      }
    }
    setLoadingSubmit(false)
  }

  let img = (
    <img
      style={{ maxWidth: '310px', width: '100%' }}
      className="img-fluid"
      src={passwordResetImg}
      alt="Password Reset"
      title="Password Reset"
    />
  )
  if (configs?._id) {
    img = <i className="mb-5 fa-regular fa-paper-plane" style={{ fontSize: '150px', color: 'var(--primary_color)' }}></i>
  }
  let content = <SqLoader size="big" />
  if (!loading) {
    content = (
      <div>
        <figure>{img}</figure>
        <p dangerouslySetInnerHTML={{ __html: t('p', { email: user?.profileadditionalinfo?.email }) }} />
        <p className="button-text">{t('titleMobile')}</p>
        <div className="buttons">
          <Button
            size="sm"
            className="back-button-password"
            onClick={() => navigate(homeNavigationPath)}
            disabled={loadingSubmit}
            color="var(--background_secondary)"
            invertedHover
            textColor="var(--text_color)"
            borderColor="var(--text_color)"
          >
            {t('back')}
          </Button>
          <Button size="sm" className="confirm-button-password" onClick={onSubmit} loading={loadingSubmit} disabled={!!impersonateUser}>
            <span className="text-mobile px-3">{t('buttonMobile')}</span>
            <span className="text-desktop">{t('buttonDesktop')}</span>
          </Button>
        </div>
      </div>
    )
  }
  return <div className="password-page">{content}</div>
}

export default withTransaction('PasswordPage', 'component')(PasswordPage)
